<template>
  <base-modal-ex v-if="isActive"
    :active.sync="isActive"
    :animation-in="animationIn"
    :animation-out="animationOut"
    :animation-duration="animationDuration"
    :can-cancel="false"
    :min-width="40"
    has-modal-card>
    <header class="modal-card-head">
      <div class="modal-card-title"
        :class="{ 'is-flex-items-center' : showIcon}">
        <span v-if="showIcon"
          class="icon is-medium"
          :class="`has-text-${iconType}`"
          style="margin-right: 0.5rem">
          <i class="mdi mdi-36px"
            :class="`${iconName}`" />
        </span>
        <span>{{ title }}</span>
      </div>
    </header>
    <section class="modal-card-body">
      <document-select v-model="selectedDocuments"
        :quote-id="quoteId"
        :is-audanet="isAudanet"
        :max-selected="maxSelected"
        :pre-select="preSelect"
        :subtitle="subtitle" />
    </section>
    <footer class="modal-card-foot">
      <div style="width: 100%; display: flex; justify-content: space-between;">
        <div style="align-self: flex-start;">
          <div v-if="showResetSent"
            class="field">
            <div class="control">
              <input class="is-checkradio is-primary"
                :class="{ 'has-background-color': isResetSent }"
                id="chk-reset-sent-documents"
                name="chk-reset-sent-documents"
                type="checkbox"
                v-model="isResetSent">
              <label for="chk-reset-sent-documents">{{ resetSentLabel }}</label>
            </div>
          </div>
        </div>
        <div class="buttons"
          style="align-self: flex-end;">
          <button class="button is-success tooltip"
            @click="submit()"
            data-tooltip="Submit"
            :disabled="submitDisabled || (selectedDocuments && selectedDocuments.length === 0)">
            <span class="icon is-small">
              <i class="mdi mdi-18px mdi-upload-multiple" />
            </span>
            <span>Submit</span>
          </button>
          <button class="button tooltip"
            @click="cancel()"
            data-tooltip="Cancel"
            :disabled="cancelDisabled">
            <span>Cancel</span>
          </button>
        </div>
      </div>
    </footer>
  </base-modal-ex>
</template>

<script>
import { BaseModalEx } from '@/components/BulmaModal'
import DocumentSelect from '@/components/DocumentSelect'

/**
 * Shared modal for selecting and submitting a quote's documents. It owns the modal
 * chrome, the DocumentSelect grid and the "Reset Sent" toggle, and emits the user's
 * selection back to the caller so each integration (AudaNet/Bridge, EstImage, ...)
 * can decide what to do with it. Reuse it rather than rebuilding the dialog.
 */
export default {
  name: 'SubmitDocumentsModal',
  components: {
    BaseModalEx,
    DocumentSelect
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    quoteId: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: 'Submit Documents'
    },
    subtitle: {
      type: String,
      default: 'Select documents to submit'
    },
    maxSelected: {
      type: Number,
      default: 99
    },
    isAudanet: {
      type: Boolean,
      default: false
    },
    preSelect: {
      type: String,
      default: 'NotSent'
    },
    showResetSent: {
      type: Boolean,
      default: true
    },
    resetSentLabel: {
      type: String,
      default: 'Reset Sent'
    },
    submitDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    animationIn: {
      type: String,
      default: 'zoomIn'
    },
    animationOut: {
      type: String,
      default: 'zoomOut'
    },
    animationDuration: {
      type: [String, Number],
      default: 0.3
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    iconType: {
      type: String,
      default: 'primary'
    },
    iconName: {
      type: String,
      default: 'mdi-file-upload'
    }
  },
  data() {
    return {
      isActive: false,
      selectedDocuments: [],
      isResetSent: false
    }
  },
  watch: {
    active(value) {
      this.isActive = value
      if (value) {
        this.selectedDocuments = []
        this.isResetSent = false
      }
    }
  },
  mounted() {
    this.isActive = this.active || false
  },
  methods: {
    submit() {
      this.$emit('submit', {
        documents: this.selectedDocuments,
        resetSent: this.isResetSent
      })
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
.is-flex-items-center {
  display: flex;
  align-items: center;
}
</style>
